BaseModel = require './base_model.coffee'

class global.ContactSpecificTemplate extends BaseModel
  @ATTRIBUTES = {
    id: {}
    flow_action_id: {}
    contact_id: {}
    template_id: {}
    subject: {}
    body: {}
    kind: {}
    signature: {}
    _destroy: false
    contact_email: {}
    contact: {}
  }

  @SERIALIZABLE_ATTRIBUTES = ['id', 'contact_id', 'template_id', 'contact_email',
                              'subject', 'body', 'signature', 'kind', '_destroy']

  belongsToContact: (contact) ->
    if contact.id
      (@contact_id || @contact.id) == contact.id
    else if contact?.email && (@contact_email || @contact?.email)
      (@contact_email || @contact.email) == contact.email



// WEBPACK FOOTER //
// ./src/models/contact_specific_template.coffee